import React from "react";
import styles from "./BIProductDisclosures.scss";
import classnames from "classnames";
import includes from "lodash/includes";

export default function BiProductDisclosures({
    products = ["heartgard_plus", "nexgard", "nexgard_plus", "nexgard_combo"]
}) {
    return (
        <div
            data-testid="bi_product_disclosures_component"
            className={classnames(styles.root, "full-width full-height flex flex-column text-notice")}
        >
            <div className="flex full-width column-to-row-sm">
                {!!includes(products, "heartgard_plus") && (
                    <div className={styles.item}>
                        <b>IMPORTANT SAFETY INFORMATION</b>: Following the use of HEARTGARD® Plus (ivermectin/pyrantel),
                        digestive and neurologic side effects and itching have been reported. All dogs should be tested for
                        heartworm infection before starting a preventive program.
                        For more information, including full prescribing information, talk to your veterinarian, call
                        888-637-4251,
                        <span> or </span>
                        <a
                            href="https://www.heartgardclinic.com/"
                            target="_blank"
                            className="text-primary"
                        >visit HEARTGARDClinic.com</a>.
                    </div>
                )}
                {!!(includes(products, "nexgard") || includes(products, "nexgard_plus") || includes(products, "nexgard_combo")) && (
                    <div className={styles.item}>
                        <span><b className="text-uppercase">Important Safety Information</b>: </span>
                        {!!includes(products, "nexgard") && (
                            <span><i>NexGard&reg;</i> (afoxolaner) </span>
                        )}
                        {!!(includes(products, "nexgard") && includes(products, "nexgard_plus")) && "and "}
                        {!!includes(products, "nexgard_plus") && (
                            <span style={{ textWrap: "nowrap" }}><i>NexGard&reg;</i> PLUS (afoxolaner, moxidectin, and pyrantel chewable tablets) </span>
                        )}
                        {!!(includes(products, "nexgard") || includes(products, "nexgard_plus")) && (
                            <span>{!!(includes(products, "nexgard") && includes(products, "nexgard_plus")) ? "are" : "is"} for use in dogs only. </span>
                        )}
                        {!!includes(products, "nexgard_combo") && (
                            <span>NG Combo<span style={{ textWrap: "nowrap" }}> (esafoxolaner, eprinomectin, and praziquantel topical solution) </span> is for use in cats only. </span>
                        )}
                        Use <i>NexGard&reg;</i> Brand Products with caution in dogs or cats with a history of seizures or neurologic disorders.
                        For more information, including full prescribing information, talk to your veterinarian, call 888-637-4251,
                        <span> or </span>
                        <a
                            href="https://www.nexgardclinic.com/"
                            target="_blank"
                            className="text-primary"
                        >visit NexGardClinic.com</a>.
                    </div>
                )}
            </div>
            <div className="full-width margin-top-sm">
                <b>
                    {!!includes(products, "heartgard_plus") && (
                        <span>HEARTGARD® Plus (ivermectin/pyrantel) and the Dog &amp; Hand logo® are registered trademarks of Boehringer Ingelheim Animal Health USA Inc. </span>
                    )}
                    {!!includes(products, "heartgard_plus") && (
                        <span><i>NexGard</i>® (afoxolaner) is a registered trademark of Boehringer Ingelheim Animal Health France, used under license. </span>
                    )}
                    {!!includes(products, "purevax") && (
                        <span className="full-width margin-top-sm">PUREVAX® is a registered trademark of Boehringer Ingelheim Animal Health France, used under license. </span>
                    )}
                    {!!(includes(products, "snap") || includes(products, "feline_triple")) && (
                        <span className="full-width margin-top-sm">
                            {!!includes(products, "snap") && "IDEXX SNAP® "}
                            {!!(includes(products, "snap") && includes(products, "feline_triple")) && "and "}
                            {!!includes(products, "feline_triple") && "Feline Triple® "}
                            {!!(includes(products, "snap") && includes(products, "feline_triple")) ? "are trademarks " : "is a trademark "}
                            <span>of IDEXX Laboratories Inc., or its affiliates in the United States and other countries. </span>
                        </span>
                    )}
                    All other trademarks are the property of their respective owner.
                    ©2025 Boehringer Ingelheim Animal Health USA Inc., Duluth, GA.
                    US-PET-0552-2025
                </b>
            </div>
        </div>
    );
}
